// -*- Mode: rjsx -*-
import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';


import { FHMaterialStyles } from "../../../ui/fh-material-styles.js";



import { CARD_TITLE_PROPS } from '..';

class PhoneClient extends React.Component {
    constructor() {
        super();
        const [value, setValue] = useState(0);
        const dispatch = useDispatch();
        const classes = FHMaterialStyles();
    }

    render() {
        return null;
    }
};								

export default PhoneClient;
